import "firebase/auth";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import {firebaseApp} from "../model/firebaseApp";
import {FirebaseStore, resetError} from "../model/store";


const actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be in the authorized domains list in the Firebase Console.
    url: `https://${process.env.REACT_APP_DOMAIN}/auth-link`,
    // This must be true.
    handleCodeInApp: true,
};


export const loginViaEmail = async (email, password) => {
    const auth = getAuth(firebaseApp);
    resetError()
    await signInWithEmailAndPassword(auth, email, password).catch(
        (error) => {
            const errorCode = error.code;
            const errorMessage = error.message;

            switch (errorCode) {
                case "auth/wrong-password":
                    FirebaseStore.update(s => {
                        s.error = "Väärä salasana tai sähköpostiosoite";
                    });
            }


            // console.log('[[loginViaEmail]]',{errorCode, errorMessage})
        }
    )
}



